import LoadingScreen from "components/LoadingScreen";
import { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";

import LayoutV3 from "layouts/layout-v3/DashboardLayout";

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );
};

// dashboards
const Dashboard = Loadable(lazy(() => import("../pages/dashboards/Dashboard")));

//App Config
const AppConfig = Loadable(lazy(() => import("../pages/app-config/AppConfig")));

// Contents
const ListContentArticlePage = Loadable(
  lazy(() => import("../pages/content/article/List")),
);
const CreateContentArticlePage = Loadable(
  lazy(() => import("../pages/content/article/Create")),
);
const EditContentArticlePage = Loadable(
  lazy(() => import("../pages/content/article/Edit")),
);

const ListContentNewsPage = Loadable(
  lazy(() => import("../pages/content/news/List")),
);
const CreateContentNewsPage = Loadable(
  lazy(() => import("../pages/content/news/Create")),
);
const EditContentNewsPage = Loadable(
  lazy(() => import("../pages/content/news/Edit")),
);

// Content Types
const ContentTypesPage = Loadable(
  lazy(() => import("../pages/content/ContentTypes")),
);

// Gallery
const ListVideoPage = Loadable(lazy(() => import("../pages/gallery/video")));

const ListPhotoPage = Loadable(lazy(() => import("../pages/gallery/photo")));
const CreatePhotoPage = Loadable(
  lazy(() => import("../pages/gallery/photo/Create")),
);

// Document Category
const DocumentCategoryPage = Loadable(
  lazy(() => import("../pages/document/Category")),
);

// Document
const ListDocumentPage = Loadable(lazy(() => import("../pages/document")));
const CreateDocumentPage = Loadable(
  lazy(() => import("../pages/document/Create")),
);
const EditDocumentPage = Loadable(lazy(() => import("../pages/document/Edit")));

// Banner
const BannerPage = Loadable(lazy(() => import("../pages/banner-slider")));

// Page
const ListPage = Loadable(lazy(() => import("../pages/page")));
const CreatePage = Loadable(lazy(() => import("../pages/page/Create")));
const EditPage = Loadable(lazy(() => import("../pages/page/Edit")));

// FAQ
const ListFAQPage = Loadable(
  lazy(() => import("../pages/master-data/faq/List")),
);
const CreateFAQPage = Loadable(
  lazy(() => import("../pages/master-data/faq/Create")),
);
const EditFAQPage = Loadable(
  lazy(() => import("../pages/master-data/faq/Edit")),
);

// Partner
const ListPartnerPage = Loadable(
  lazy(() => import("../pages/master-data/partner")),
);
const CreatePartnerPage = Loadable(
  lazy(() => import("../pages/master-data/partner/Create")),
);
const EditPartnerPage = Loadable(
  lazy(() => import("../pages/master-data/partner/Edit")),
);

//Benefit
const BenefitPage = Loadable(
  lazy(() => import("../pages/master-data/benefit")),
);

// Popup
const PopupPage = Loadable(lazy(() => import("../pages/popup")));

// Survey
const SurveyPage = Loadable(lazy(() => import("../pages/survey")));

// Visi-Misi
const VisiMisiPage = Loadable(lazy(() => import("../pages/visi-misi")));

// Statistics
const StatisticsPage = Loadable(lazy(() => import("../pages/statistics")));

// Organization
const OrganizationPage = Loadable(lazy(() => import("../pages/organization")));

// Organization Profile & Core Value
const OrganizationProfilePage = Loadable(
  lazy(() => import("../pages/organization-profile")),
);

// Organization History
const OrganizationHistoryPage = Loadable(
  lazy(() => import("../pages/organization-history")),
);
const CreateOrganizationHistoryPage = Loadable(
  lazy(() => import("../pages/organization-history/Create")),
);
const EditOrganizationHistoryPage = Loadable(
  lazy(() => import("../pages/organization-history/Edit")),
);

// Sitemap
const SitemapPage = Loadable(lazy(() => import("../pages/sitemap")));

// Event
const EventPage = Loadable(lazy(() => import("../pages/event")));
const CreateEventPage = Loadable(lazy(() => import("../pages/event/Create")));
const EditEventPage = Loadable(lazy(() => import("../pages/event/Edit")));
const EventLogPage = Loadable(lazy(() => import("../pages/event/Log")));

// Wasit
const WasitPage = Loadable(lazy(() => import("../pages/wasit")));
const CreateWasitPage = Loadable(lazy(() => import("../pages/wasit/Create")));
const EditWasitPage = Loadable(lazy(() => import("../pages/wasit/Edit")));

// Athlete
const AthletePage = Loadable(lazy(() => import("../pages/atlet")));
const CreateAthletePage = Loadable(lazy(() => import("../pages/atlet/Create")));
const EditAthletePage = Loadable(lazy(() => import("../pages/atlet/Edit")));

// Tournament Result
const TournamentResultPage = Loadable(
  lazy(() => import("../pages/tournament-result")),
);
const CreateTournamentResultPage = Loadable(
  lazy(() => import("../pages/tournament-result/Create")),
);
const EditTournamentResultPage = Loadable(
  lazy(() => import("../pages/tournament-result/Edit")),
);

// Program
const ProgramPage = Loadable(lazy(() => import("../pages/program")));
const CreateProgramPage = Loadable(
  lazy(() => import("../pages/program/Create")),
);
const EditProgramPage = Loadable(lazy(() => import("../pages/program/Edit")));
const ProgramLogPage = Loadable(lazy(() => import("../pages/program/Log")));

// Wasit Certification Level
const WasitCertificationLevelPage = Loadable(
  lazy(() => import("../pages/wasit-certification-level")),
);
const CreateWasitCertificationLevelPage = Loadable(
  lazy(() => import("../pages/wasit-certification-level/Create")),
);
const EditWasitCertificationLevelPage = Loadable(
  lazy(() => import("../pages/wasit-certification-level/Edit")),
);

// Roles
const RolePage = Loadable(
  lazy(() => import("../pages/master-data/role/ListRole")),
);

// User
const UserPage = Loadable(
  lazy(() => import("../pages/master-data/users/ListUser")),
);

// Login Pages
const LoginV2 = Loadable(
  lazy(() => import("../pages/authentication/login-v2")),
);

// Register Pages
const Register = Loadable(
  lazy(() => import("../pages/authentication/register")),
);

//Organization Unit Pages
const OrganizationUnitPage = Loadable(
  lazy(() => import("../pages/master-data/organization-unit")),
);

// Unit Tasks Pages
const UnitTasksPage = Loadable(
  lazy(() => import("../pages/master-data/unit-tasks")),
);

// Error page
const Error = Loadable(lazy(() => import("../pages/404")));

// Organization Structure
const OrganizationStructurePage = Loadable(
  lazy(() => import("../pages/master-data/organization-structure")),
);

const OauthSuccess = Loadable(
  lazy(() => import("../pages/authentication/OauthSuccess")),
);

const PageManagement = Loadable(
  lazy(() => import("../pages/master-data/page-management")),
);

const VerifyRole = Loadable(
  lazy(() => import("../pages/authentication/VerifyRole")),
);
const routes = (isAuth) => {
  return [
    ...authRoutes(isAuth),
    {
      path: "",
      element: isAuth ? <LayoutV3 /> : <Navigate to="/login" />,
      children: dashboardRoutes,
    },
    {
      path: "*",
      element: <Error />,
    },
  ];
};

const authRoutes = (isAuth) => [
  {
    path: "/",
    element: !isAuth ? <Navigate to="/login" /> : <Navigate to="/dashboard" />,
  },
  {
    path: "login",
    element: !isAuth ? <LoginV2 /> : <Navigate to="/dashboard" />,
  },
  {
    path: "verify-role",
    element: !isAuth ? <VerifyRole /> : <Navigate to="/dashboard" />,
  },
  {
    path: "register",
    element: <Register />,
  },
  {
    path: "oauth-success",
    element: <OauthSuccess />,
  },
];
const dashboardRoutes = [
  {
    path: "dashboard",
    element: <Dashboard />,
  },
  {
    path: "app-config",
    element: <AppConfig />,
  },
  {
    path: "banner",
    element: <BannerPage />,
  },
  {
    path: "page",
    children: [
      {
        path: "",
        element: <ListPage />,
      },
      {
        path: "create",
        element: <CreatePage />,
      },
      {
        path: "edit/:_id",
        element: <EditPage />,
      },
    ],
  },
  {
    path: "faq",
    children: [
      {
        path: "",
        element: <ListFAQPage />,
      },
      {
        path: "create",
        element: <CreateFAQPage />,
      },
      {
        path: "edit/:_id",
        element: <EditFAQPage />,
      },
    ],
  },
  {
    path: "content",
    children: [
      {
        path: "type",
        element: <ContentTypesPage />,
      },
      {
        path: "article",
        children: [
          {
            path: "list",
            element: <ListContentArticlePage />,
          },
          {
            path: "create",
            element: <CreateContentArticlePage />,
          },
          {
            path: "edit/:_id",
            element: <EditContentArticlePage />,
          },
        ],
      },
      {
        path: "news",
        children: [
          {
            path: "list",
            element: <ListContentNewsPage />,
          },
          {
            path: "create",
            element: <CreateContentNewsPage />,
          },
          {
            path: "edit/:_id",
            element: <EditContentNewsPage />,
          },
        ],
      },
    ],
  },
  {
    path: "document",
    children: [
      {
        path: "",
        element: <ListDocumentPage />,
      },
      {
        path: "category",
        element: <DocumentCategoryPage />,
      },
      {
        path: "create",
        element: <CreateDocumentPage />,
      },
      {
        path: "edit/:_id",
        element: <EditDocumentPage />,
      },
    ],
  },
  {
    path: "gallery",
    children: [
      {
        path: "photo",
        children: [
          {
            path: "",
            element: <ListPhotoPage />,
          },
          {
            path: "create",
            element: <CreatePhotoPage />,
          },
        ],
      },
      {
        path: "video",
        children: [
          {
            path: "",
            element: <ListVideoPage />,
          },
        ],
      },
    ],
  },
  {
    path: "popup",
    element: <PopupPage />,
  },
  {
    path: "survey",
    element: <SurveyPage />,
  },
  {
    path: "visi-misi",
    element: <VisiMisiPage />,
  },
  {
    path: "statistics",
    element: <StatisticsPage />,
  },
  {
    path: "organization-structure",
    element: <OrganizationStructurePage />,
  },
  {
    path: "partner",
    children: [
      {
        path: "",
        element: <ListPartnerPage />,
      },
      {
        path: "create",
        element: <CreatePartnerPage />,
      },
      {
        path: "edit/:_id",
        element: <EditPartnerPage />,
      },
    ],
  },
  {
    path: "benefit",
    element: <BenefitPage />,
  },
  {
    path: "organization",
    element: <OrganizationPage />,
  },
  {
    path: "organization-profile",
    element: <OrganizationProfilePage />,
  },
  {
    path: "organization-history",
    children: [
      {
        path: "",
        element: <OrganizationHistoryPage />,
      },
      {
        path: "create",
        element: <CreateOrganizationHistoryPage />,
      },
      {
        path: "edit/:_id",
        element: <EditOrganizationHistoryPage />,
      },
    ],
  },
  {
    path: "sitemap",
    element: <SitemapPage />,
  },
  {
    path: "Event",
    children: [
      {
        path: "",
        element: <EventPage />,
      },
      {
        path: "log",
        element: <EventLogPage />,
      },
      {
        path: "create",
        element: <CreateEventPage />,
      },
      {
        path: "edit/:_id",
        element: <EditEventPage />,
      },
    ],
  },
  {
    path: "wasit",
    children: [
      {
        path: "",
        element: <WasitPage />,
      },
      {
        path: "create",
        element: <CreateWasitPage />,
      },
      {
        path: "edit/:_id",
        element: <EditWasitPage />,
      },
    ],
  },
  {
    path: "atlet",
    children: [
      {
        path: "",
        element: <AthletePage />,
      },
      {
        path: "create",
        element: <CreateAthletePage />,
      },
      {
        path: "edit/:_id",
        element: <EditAthletePage />,
      },
    ],
  },
  {
    path: "tournament-result",
    children: [
      {
        path: "",
        element: <TournamentResultPage />,
      },
      {
        path: "create",
        element: <CreateTournamentResultPage />,
      },
      {
        path: "edit/:_id",
        element: <EditTournamentResultPage />,
      },
    ],
  },
  {
    path: "program",
    children: [
      {
        path: "",
        element: <ProgramPage />,
      },
      {
        path: "log",
        element: <ProgramLogPage />,
      },
      {
        path: "create",
        element: <CreateProgramPage />,
      },
      {
        path: "edit/:_id",
        element: <EditProgramPage />,
      },
    ],
  },
  {
    path: "wasit-certification-level",
    children: [
      {
        path: "",
        element: <WasitCertificationLevelPage />,
      },
      {
        path: "create",
        element: <CreateWasitCertificationLevelPage />,
      },
      {
        path: "edit/:_id",
        element: <EditWasitCertificationLevelPage />,
      },
    ],
  },
  {
    path: "role",
    element: <RolePage />,
  },
  {
    path: "users",
    element: <UserPage />,
  },
  {
    path: "page-management",
    element: <PageManagement />,
  },
  {
    path: "organization-unit",
    children: [
      {
        path: "",
        element: <OrganizationUnitPage />,
      },
      {
        path: "unit-tasks/:_id",
        element: <UnitTasksPage />,
      },
    ],
  },
];
export default routes;
